import React from 'react'

import { Typography, makeStyles, createStyles, Theme } from '@material-ui/core'
import Lottie from 'react-lottie'

import checkmarkDoneAnimation from 'assets/animations/checkmark-done.json'
import { useTranslations } from 'locales'
import { desktopStyle } from 'utils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      textAlign: 'center',
      position: 'fixed',
      background: theme.palette.common.brandBlue,
      height: '100%',
      width: '100%',
      '& >h4': {
        color: theme.palette.common.white,
      },
      paddingLeft: '5%',
      paddingRight: '5%',
      ...desktopStyle({
        height: '100%',
        paddingLeft: '30%',
        paddingRight: '30%',
      }),
    },
    animation: {
      paddingTop: '25%',
      paddingBottom: 30,
    },
  }),
)

const AllSetScreen: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslations()

  return (
    <div className={classes.container}>
      <div className={classes.animation}>
        <Lottie
          options={{
            animationData: checkmarkDoneAnimation,
            loop: false,
          }}
          height={100}
          width={100}
        />
      </div>
      <Typography variant="h4" color="primary">
        {t("You're all set!")}
        <br />
        {t('Thank you, we appreciate your feedback.')}
      </Typography>
    </div>
  )
}

export default AllSetScreen
